module.exports = __webpack_public_path__ + "static/img/silverlining-logo.7ddb18e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/silverlining-logo.png
// module id = LRMN
// module chunks = 0